import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Filter } from '../../filter';
import { LocalStorage } from '../../local-storage.class';
import { Settings } from '../../settings.class';
import { AuthorisationService } from '../auth/authorisation.service';
import { Functionalities } from '../auth/functionalities';
import { CustomerProjectService } from '../customer-project/customer-project.service';
import { WorkareaService } from '../workarea/workarea.service';
import { ExportExcelBuilderService } from './export-excel-builder/export-excel-builder.service';

@Injectable()
export class ExportService {
    constructor(
        private workareaService: WorkareaService,
        private customerProjectService: CustomerProjectService,
        private exportExcelBuilderService: ExportExcelBuilderService
    ) {}

    downloadExcelWorkareas(
        customer_project_id: number,
        workarea_ids?: number[],
        statusIds?: number[]
    ): Observable<void> {
        const workareas$ = this.workareaService.getAllForExport({
            statuses: statusIds?.length ? statusIds : null,
            customerProjectId: customer_project_id,
        });
        const project$ = this.customerProjectService
            .getProject(customer_project_id)
            .pipe(map(response => response.data));

        return forkJoin([workareas$, project$]).pipe(
            switchMap(async ([allWorkareas, project]) => {
                const filter = new Filter();
                filter.project = customer_project_id;
                filter.workarea_ids = workarea_ids ?? [];
                const workareas = filter.apply(allWorkareas);
                const customer = LocalStorage.getCustomer();
                // GeoRestricted users get a reduced extra/areas from the API; keep those cells empty
                const restricted = AuthorisationService.hasFunctionality(Functionalities.GeoRestricted);
                const buffer = await this.exportExcelBuilderService.build(workareas, project, restricted);
                Settings.saveAsExcelFile(buffer, `Excel ${customer.name} - ${project.name}`);
            })
        );
    }
}
